var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"succes_dec"},[_c('img',{attrs:{"src":_vm.imgPath+'duiahuncg.png',"alt":""}}),_c('h4',[_vm._v("支付成功")]),_c('p',[_vm._v("您可以订单列表里查看详情")])]),_c('div',{staticClass:"my_btn"},[_c('p',{on:{"click":_vm.goHome}},[_vm._v("返回首页")]),_c('p',{on:{"click":_vm.checkOrder}},[_vm._v("查看订单")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }